import React, { useEffect, useState } from 'react';
import $ from 'jquery';
import Downshift from 'downshift';
import SchoolSelectInput from './search_school/SchoolSelectInput';
import ClassRoomInput from './search_school/ClassRoomInput';
import { endpoints } from '../utils/api';

const StartAutocompleteAtLength = 2;

export default function SearchSchool({
  classes,
  label,
  required,
  resourceName,
  selectClassRoom,
  existingSchools,
  existingClassRoom,
  addSchoolToSchoolList,
  showSchoolAddingHint
}) {
  const [currentRequest, setCurrentRequest] = useState(null);
  const [requestError, setRequestError] = useState(null);

  const [selectedSchool, setSelectedSchool] = useState(null);
  const [selectedClassRoom, setSelectedClassRoom] = useState(null);

  const [city, setCity] = useState('');
  const [chosenCity, setChosenCity] = useState('');
  const [autocompleteCitySuggestions, setAutocompleteCitySuggestions] = useState({});
  const [autocompleteSchoolsSuggestions, setSearchSchoolsSuggestions] = useState([]);
  const [autocompleteNoResult, setAutocompleteNoResult] = useState(false);

  const [schoolsInCitySuggestions, setSchoolsInCitySuggestions] = useState([]);
  const [classRoomsSuggestions, setClassRoomsSuggestions] = useState(null);

  const [grade, setGrade] = useState(null);



  const currentCityString = () => {
    if (city === null || city === undefined) {
      return '';
    }
    return city.length === 0 && existingSchools.length > 0
      ? existingSchools.slice(-1)[0].city
      : city.replace(/<b>/g, '').replace(/<\/b>/g, '');
  };

  const emitRequest = (cityName) => {
    setCurrentRequest(
      $.ajax({ type: 'POST', url: endpoints['apiSearchSchool'](), data: { query: cityName, grade: grade } })
        .done(fetchDone)
        .fail(fetchFail),
    );
  };

  const fetchDone = (result) => {
    setAutocompleteCitySuggestions(result.match_by_city);
    setSearchSchoolsSuggestions(result.match_by_name);
    const withNoMatch = isEmpty(result.match_by_name) && isEmpty(result.match_by_city)
    setAutocompleteNoResult((chosenCity === '') && withNoMatch);
    setRequestError(null);
    setCurrentRequest(null);
  };

  const isEmpty = (object) => { return Object.keys(object).length === 0; }

  const fetchFail = (xhr, textStatus) => {
    if (textStatus === 'abort') {
      return;
    }
    setRequestError('Une erreur est survenue, veuillez ré-essayer plus tard.');
    setCurrentRequest(null);
    setAutocompleteNoResult(false);
    setAutocompleteCitySuggestions({});
    setSearchSchoolsSuggestions([]);
    setSchoolsInCitySuggestions([]);
    setClassRoomsSuggestions(null);
  };

  const onResetSearch = () => {
    setCity(null);
    setChosenCity('');
    setSelectedSchool(null);
    setSelectedClassRoom(null);
    setAutocompleteCitySuggestions({});
    setSearchSchoolsSuggestions([]);
    setSchoolsInCitySuggestions([]);
    setClassRoomsSuggestions(null);
    setAutocompleteNoResult(false);
    setCurrentRequest(null);
  };

  // search is done by city or school
  // either we find city
  // either we find school
  // based on selection (string:city, object:school)
  // see: https://github.com/downshift-js/downshift#onchange
  const onDownshiftChange = (selectedItem) => {
    if (autocompleteCitySuggestions.hasOwnProperty(selectedItem)) {
      setCity(selectedItem);
      setSchoolsInCitySuggestions(autocompleteCitySuggestions[selectedItem]);
      setClassRoomsSuggestions(null);
    } else {
      setCity(selectedItem.city);
      setSchoolsInCitySuggestions([selectedItem]);
      setSelectedSchool(selectedItem);
      setClassRoomsSuggestions(selectedItem.class_rooms);
    }
    setChosenCity(selectedItem);
    setAutocompleteCitySuggestions({});
    setSearchSchoolsSuggestions([]);
    if((selectedItem.id != undefined) && (selectedItem.name != undefined )) {
      addSchoolToSchoolList(
        { schoolId: selectedItem.id,
          schoolName: selectedItem.name,
          schoolQpv: selectedItem.qpv,
          schoolRepKind: selectedItem.rep_kind
        },
      );
      onResetSearch();
    }

  };

  const schoolNameComputed = (school) => {
  if (!school) return '';

  const rep_wording = school.rep_kind === 'rep_plus' ? ' [REP+]' : school.rep_kind === 'rep' ? ' [REP]' : '';
    return (school.pg_search_highlight_name || school.name) + (school.qpv ? ' [QPV]' : '') + rep_wording;
  };

  const inputChange = (event) => {
    setCity(event.target.value);
    if (event.target.value === '') { onResetSearch()}
  }

  const renderAutocompleteInput = () => {
    const search_label = "Adresse ou commune de l'établissement";
    return (
      <Downshift
        initialInputValue={city}
        onChange={onDownshiftChange}
        selectedItem={city}
        itemToString={(item) => {
          item && item.properties ? item.properties.label : '';
        }}
      >
        {({
          getLabelProps,
          getInputProps,
          getItemProps,
          getMenuProps,
          isOpen,
          highlightedIndex,
          selectedItem,
        }) => (
          <div id="header-search" className="custom-label-container fr-mr-6w" role="search">
            <label
             {...getLabelProps({ className: 'fr-label', htmlFor: `${resourceName}_school_city` })}
            >
              {label}
            </label>
            <div className='d-flex'>
              <input
                {...getInputProps({
                  onChange: inputChange,
                  value: currentCityString(),
                  className: `fr-input fr-mb-2w w-100 ${classes || ''} ${
                    autocompleteNoResult ? '' : 'rounded-0'
                  }`,
                  id: `${resourceName}_school_city`,
                  placeholder: search_label,
                  name: `${resourceName}[school][city]`,
                  required: required,
                })}
              />
              {!currentRequest && (
                <button
                  type="button"
                  title={search_label}
                  className={`fr-btn flex-shrink-1 btn-clear-city fr-icon fr-icon-delete-line ml-1 ${
                    autocompleteNoResult ? '' : 'rounded-0'
                  }`}
                  onClick={onResetSearch}
                  aria-label="Réinitialiser la recherche"
                >
                </button>
              )}
              {currentRequest && (
                <button
                  type="button"
                  title={search_label}
                  className="fr-btn btn-clear-city flex-shrink-1"
                  onClick={onResetSearch}
                  aria-label="Réinitialiser la recherche"
                >
                  <span className="fr-icon-close-line"></span>
                </button>
              )}
            </div>


            <div className="search-in-place bg-white shadow">
              <ul
                {...getMenuProps({
                  className: `${
                    classes || ''
                  } list-group p-0 shadow-sm autocomplete-school-results`,
                })}
              >
                {isOpen ? (
                  <>
                    <li
                      className={`list-group-item list-group-item-secondary rounded-0 small py-2 ${
                        Object.keys(autocompleteCitySuggestions || {}).length > 0 ? '' : 'd-none'
                      }`}
                    >
                      Communes(s)
                    </li>
                    {Object.keys(autocompleteCitySuggestions || {}).map((currentCity, index) => (
                      <li
                        {...getItemProps({
                          index,
                          item: currentCity,
                          className: `list-group-item list-group-item-action d-flex justify-content-between align-items-center listview-item ${
                            highlightedIndex === index ? 'highlighted-listview-item' : ''
                          }`,
                          key: `city-${currentCity}`,
                        })}
                      >
                        <span  className="fr-mx-1w" dangerouslySetInnerHTML={{ __html: currentCity }} />
                        <span className="fr-badge fr-badge--sm fr-badge--success fr-badge--no-icon fr-ml-1w">
                          {autocompleteCitySuggestions[currentCity].length} établissement
                          {autocompleteCitySuggestions[currentCity].length > 1 ? 's' : ''}
                        </span>
                      </li>
                    ))}
                    <li
                      className={`list-group-item list-group-item-secondary small py-2 ${
                        (autocompleteSchoolsSuggestions || []).length > 0 ? '' : 'd-none'
                      }`}
                    >
                      Etablissement(s)
                    </li>
                    {
                      (autocompleteSchoolsSuggestions || []).reduce(
                        (accumulator, currentSchool) => {
                          const index = accumulator.itemIndex++;

                          accumulator.result.push(
                            <li
                              {...getItemProps({
                                index,
                                item: currentSchool,
                                className: `list-group-item list-group-item-action text-left listview-item ${
                                  highlightedIndex === index ? 'highlighted-listview-item' : ''
                                }`,
                                key: `school-${currentSchool.id}`,
                              })}
                            >
                              <span
                                dangerouslySetInnerHTML={{
                                  __html: schoolNameComputed(currentSchool),
                                }}
                              />
                              <br />
                              <small>
                                {currentSchool.city} – {currentSchool.zipcode}
                              </small>
                            </li>,
                          );
                          return accumulator;
                        },
                        {
                          result: [],
                          itemIndex: Object.keys(autocompleteCitySuggestions || {}).length,
                        },
                      ).result
                    }
                  </>
                ) : null}
                {requestError && (
                  <li className="list-group-item list-group-item-danger small">{requestError}</li>
                )}
                {autocompleteNoResult && (
                  <li className="list-group-item list-group-item-info small">
                    Aucun résultat pour votre recherche. Assurez-vous que l’établissement renseigné
                    est un lycée général ou technologique ou un collège.
                  </li>
                )}
              </ul>
            </div>
          </div>
        )}
      </Downshift>
    );
  };

  useEffect(() => {
    if (city && city.length > StartAutocompleteAtLength) {
      emitRequest(city);
    } else {
      setAutocompleteCitySuggestions({});
    }
  }, [city]);

  useEffect(() => {
    const handleGradeChange = (event) => {
      setGrade(event.detail.grade)
    }
    document.addEventListener('gradeChanged', handleGradeChange)
    return () => {
      document.removeEventListener('gradeChanged', handleGradeChange)
    }
  }, [])

  return (
    <div className="autocomplete-school-container">
      {renderAutocompleteInput()}
      {(showSchoolAddingHint) && (
        <small className="text-muted">
          Vous pouvez réserver ce stage à plusieurs établissements en recommençant une recherche.
        </small>
      )}
      {city !== null && (
        <>
          <SchoolSelectInput
            setClassRoomsSuggestions={setClassRoomsSuggestions}
            selectedSchool={selectedSchool}
            setSelectedSchool={setSelectedSchool}
            schoolsInCitySuggestions={schoolsInCitySuggestions}
            resourceName={resourceName}
            existingSchools={existingSchools}
            classes={classes}
            addSchoolToSchoolList={addSchoolToSchoolList}
            onResetSearch={onResetSearch}
            schoolNameComputed={schoolNameComputed}
          />

          {selectClassRoom && (
            <ClassRoomInput
              selectedClassRoom={selectedClassRoom}
              classRoomsSuggestions={classRoomsSuggestions}
              resourceName={resourceName}
              existingClassRoom={existingClassRoom}
              classes={classes}
            />
          )}
        </>
      )}
    </div>
  );
}
